export default {"src":"/_next/static/media/home-customer-obsessed.935f301b.svg","height":66,"width":70,"blurWidth":0,"blurHeight":0};